import { useCallback } from 'react'
import Button from '@mui/material/Button'

const AddColumnButton = ({ onClick }) => {
  const handleClick = useCallback(() => {
    if (onClick) onClick()
  }, [onClick])

  return (
    <Button
      onClick={handleClick}
      disableElevation
      disableFocusRipple
      disableRipple
      variant='outlined'
      sx={{
        fontSize: 14,
        textTransform: 'none',
        minWidth: '200px',
        width: '200px',
        height: '500px',
        borderColor: 'primary',
        borderStyle: 'dashed',
        borderWidth: '3px',
        borderRadius: 0,
      }}
    >
      + Add Column
    </Button>
  )
}

export default AddColumnButton
